import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IContact } from 'app/interfaces/contact.interface';
import { DateTime } from 'luxon';

export type PlanType =
	| 'periodically_subscription'
	| 'corporate_subscription'
	| 'benefit'
	| 'discount_subscription';

@Component({
	selector: 'details-contact-info',
	templateUrl: './details-contact-info.component.html',
	styleUrls: ['./details-contact-info.component.scss'],
})
export class DetailsContactInfoComponent implements OnChanges {
	gender;
	age;
	location;
	contactPlanType;
	info = [];
	constructor(private translateService: TranslateService) {}

	@Input() payment: PlanType;
	@Input() contact: IContact;

	async ngOnChanges(changes: SimpleChanges) {
		if (changes.contact?.currentValue) {
			this.contactPlanType = this.getContactPlanType(this.payment);
			this.age = this.getAge(this.contact.birthdate);
			this.gender = await this.getGender(this.contact.gender);
			this.location = this.getLocation(this.contact);
			this.setInfoArray();
		}
	}

	setInfoArray() {
		this.info = [];
		if (this.age) {
			this.info.push(this.age);
		}
		if (this.location) {
			this.info.push(this.location);
		}
		if (this.gender) {
			this.info.push(this.gender);
		}
	}

	getContactPlanType(paymentType) {
		if (paymentType === 'corporate_subscription') {
			return this.translateService.instant('GENERAL.CORPORATE_CONTACT');
		}
		return this.translateService.instant('GENERAL.PARTICULAR_CONTACT');
	}

	getAge(birthdate: string): string {
		if (!birthdate) {
			return '';
		}
		const noSlashBirthdate = birthdate.replace(/(\/)/g, '-');
		const datePT = DateTime.fromFormat(noSlashBirthdate, 'dd-MM-yyyy');
		const dateEN = DateTime.fromFormat(noSlashBirthdate, 'yyyy-MM-dd');

		const { years: contactAge } = DateTime.now()
			.diff(datePT['invalid'] ? dateEN : datePT, 'years')
			.toObject();

		return `${Math.floor(contactAge)} ${this.translateService.instant(
			'SESSION.USERINFO.YEARS'
		)}`;
	}

	getLocation(contact: IContact): string {
		const { city, state } = contact;
		const label = this.translateService.instant(
			'SESSION.USERINFO.LIVES_AT_CAPITALIZE'
		);

		if (city && state) {
			return `${label} ${city} - ${state}`;
		}

		if (city) {
			return `${label} ${city}`;
		}

		if (state) {
			return `${label} ${state}`;
		}

		return '';
	}

	async getGender(genderValue: string) {
		const genderOptionsPath = 'MY_ACCOUNT.PERSONAL.GENDER_OPTIONS';
		return this.translateService
			.get([genderOptionsPath])
			.toPromise()
			.then(({ [genderOptionsPath]: optionsObj }) => {
				for (const property in optionsObj) {
					const option = optionsObj[property];
					if (option.value === genderValue) {
						return option.label;
					}
				}
			});
	}

	formatedInfo() {
		return this.info.join(' | ');
	}
}
